import actions from '../actions'
import { ProductsState } from '../types'

const reducer = {
  [actions.saveFeature.type]: (state: ProductsState) => ({ ...state, updating: true }),
}
export default reducer
